import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NotificationsBanner.css';

const NOTIFICATION_ID = 'soc2_type2_attestation_2026'; // Unique ID for this notification
const STORAGE_KEY = 'dismissed_notifications';

const NotificationsBanner = () => {
  const [isVisible, setIsVisible] = useState(false); // Start with false and check localStorage

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const forceShow = ['1', 'true', 'yes'].includes((params.get('showNotification') || '').toLowerCase());
    if (forceShow) {
      setIsVisible(true);
      return;
    }

    // Check if this notification was previously dismissed
    const dismissedNotifications = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const shouldShow = !dismissedNotifications.includes(NOTIFICATION_ID);
    setIsVisible(shouldShow);
  }, []);

  useEffect(() => {
    // Dispatch event when visibility changes
    const event = new CustomEvent('notificationVisibilityChange', {
      detail: { visible: isVisible }
    });
    window.dispatchEvent(event);
  }, [isVisible]);

  const handleDismiss = () => {
    // Get current dismissed notifications
    const dismissedNotifications = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    
    // Add this notification ID if not already present
    if (!dismissedNotifications.includes(NOTIFICATION_ID)) {
      dismissedNotifications.push(NOTIFICATION_ID);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(dismissedNotifications));
    }
    
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <aside className="notifications-banner" aria-label="Latest compliance update">
      <div className="notifications-container">
        <div className="notifications-content">
          <p className="notifications-message">
            <strong>Compliance milestone:</strong>{' '}
            Circumvent achieves SOC 2 Type 2 attestation with a clean report after independent examination of operating controls.{' '}
            <Link to="/blog/soc-2-type-2-attestation" className="notifications-link">
              Read the SOC 2 Type 2 announcement
            </Link>
          </p>
          <button 
            className="notifications-close" 
            onClick={handleDismiss}
            aria-label="Close notification"
          >
            ×
          </button>
        </div>
      </div>
    </aside>
  );
};

export default NotificationsBanner; 